import { Link, useNavigate } from "react-router-dom";
import { LogIn, LogOut, UserRound } from "lucide-react";
import { useAuth, HOME_BY_ROLE } from "@/lib/auth";
import { useI18n } from "@/lib/i18n/i18n";

export const UserChip = ({ dark = false }) => {
  const { user, logout, loading } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  if (loading) return null;
  if (!user) {
    return (
      <Link to="/login" className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${dark ? "border border-white/15 text-white/80 hover:bg-white/10" : "border border-slate-200 text-slate-700 hover:border-slate-900"}`} data-testid="user-login-link">
        <LogIn className="h-3.5 w-3.5" /> {t("Acceder")}
      </Link>
    );
  }
  const home = user.role === "company" && !user.companyId ? `/empresas/inscripcion/${user.applicationId}` : HOME_BY_ROLE[user.role];
  return (
    <span className="flex items-center gap-1">
      <Link to={home} className={`hidden max-w-[160px] items-center gap-1.5 truncate rounded-full px-3 py-1.5 text-xs font-semibold sm:flex ${dark ? "text-white/80 hover:bg-white/10" : "text-slate-700 hover:bg-slate-100"}`} data-testid="user-chip-name">
        <UserRound className="h-3.5 w-3.5 shrink-0" /><span className="truncate">{user.name}</span>
      </Link>
      <button onClick={() => { logout(); nav("/login"); }} title={t("Cerrar sesión")} className={`flex h-8 w-8 items-center justify-center rounded-full transition-colors ${dark ? "text-white/70 hover:bg-white/10" : "text-slate-500 hover:bg-slate-100 hover:text-slate-900"}`} data-testid="user-logout-button">
        <LogOut className="h-4 w-4" />
      </button>
    </span>
  );
};
